import { Controller } from '@hotwired/stimulus';
import { fireChangeEvent } from '../search/accordion_change';
import { translate } from '../../utils/translation';

const MAX_RADIUS_LENGTH = 3;

export default class LocationController extends Controller {
  static targets = ['settlementSelect', 'settlementHiddenInput', 'radiusInput', 'countySelect'];

  connect() {
    fireChangeEvent(this.element, this._getDisplayText());
    this.countyDisplayValue = '';
  }

  onSettlementChange(e) {
    const settlementId = e.detail.value.settlementId;
    this.settlementHiddenInputTarget.value = settlementId;
    this.radiusInputTarget.disabled = !settlementId;
    if (!settlementId) {
      this.radiusInputTarget.value = '';
    }

    fireChangeEvent(this.element, this._getDisplayText());
  }

  onCountyChange(e) {
    this.countyDisplayValue = e.detail.displayValue;

    fireChangeEvent(this.element, this._getDisplayText());
  }

  onRadiusInput() {
    const input = this.radiusInputTarget;
    input.value = input.value.replace(/\D/g, '').replace(/^0+/, '').slice(0, MAX_RADIUS_LENGTH);
  }

  onRadiusChange() {
    fireChangeEvent(this.element, this._getDisplayText());
  }

  _getDisplayText() {
    const text = [];

    if (this.settlementSelectTarget.value) {
      text.push(this.settlementSelectTarget.value);
    }

    if (this.radiusInputTarget.value) {
      text.push(translate('common.search_form.location.radius_display', { value: this.radiusInputTarget.value }));
    }

    if (this.countyDisplayValue) {
      text.push(translate('common.search_form.location.county_display', { value: this.countyDisplayValue }));
    }

    return text.join(', ');
  }
}
